import { Card } from "@avenueops/web-components";
import NotificationPreview from "../editFormReboot/NotificationPreview";
import SignalFormatInput from "../editFormReboot/SignalFormatInput";
import { MetricMetaKeys } from "@avenueops/shared-types";
import { NotificationType } from "@prisma/client";
import { useQueryColumns, useEnrichmentColumns, useQueryRunResults } from "context/QueryRunContext";
import _ from "lodash";
import { useFormContext } from "react-hook-form";

interface Props {
  control: any;
  notificationPrefix: string;
  notificationType: NotificationType;
  includeTitle?: boolean;
  useMarkdown?: boolean;
}

export default function SubscriberSignalFormat({ notificationPrefix, notificationType, includeTitle = true, useMarkdown = true }: Props): JSX.Element {
  const { control, watch, setValue } = useFormContext();
  const workflowType = watch("workflowType");
  const messageFormat = watch(`${notificationPrefix}.messageFormat`);
  const workflowTriggerType = watch("workflowTriggerType");

  const { queryRunResults } = useQueryRunResults();
  const queryColumns = useQueryColumns();
  const enrichmentColumns = useEnrichmentColumns();
  const formatOptions = workflowType === "METRIC" ? MetricMetaKeys : [...queryColumns, ...enrichmentColumns];

  return (
    <Card>
      <div className="p-5 w-full">
        <SignalFormatInput
          control={control}
          titleFormatConfig={{ name: `${notificationPrefix}.titleFormat`, includeTitle: includeTitle }}
          messageFormatConfig={{ name: `${notificationPrefix}.messageFormat`, useMarkdown: useMarkdown }}
          formatOptions={formatOptions}
        />
        {queryRunResults && queryRunResults.length > 0 ? <NotificationPreview notificationPrefix={notificationPrefix} previewType={notificationType} /> : null}
      </div>
    </Card>
  );
}
